import { setHasValueClass } from '../../../resources/assets/scripts/components/select-list';

const SELF_SERVICE_API_HOST = window.selfService.api_url;

/**
 * Initializes the custom address picker field for each form on the page by
 * retrieving the user's addresses and injecting them in a dropdown field.
 */
const createAddressPicker = async () => {
  const currentSession = window.andel?.auth?.currentSession?.();

  const formEls = document.querySelectorAll('form[id^="wpforms-form-"]');
  for (const formEl of formEls) {
    const selectData = getSelect(formEl);
    if (!selectData) {
      return;
    }

    const { selectContainer, selectEl } = selectData;
    try {
      const session = await currentSession;
      if (!session?.authenticated) {
        throw Error('Not logged in');
      }

      const addresses = await getAddresses();
      injectAddresses(addresses, selectEl, selectContainer);
    } catch (e) {
      console.log(e);
      showError(formEl, selectEl, selectContainer);
    }
  }
};

window.addEventListener('load', createAddressPicker);

/**
 * Finds the address picker field and its select in a form.
 */
const getSelect = (formEl) => {
  const selectContainer = formEl.querySelector('.wpforms-field-address_picker');
  const selectEl = selectContainer?.querySelector('select');

  if (!selectEl) {
    return null;
  }

  return { selectContainer, selectEl };
};

/**
 * If the user isn't logged in, manually create an error message and stop the
 * form from submitting, so we don't have to deal with the jQuery validator.
 */
const showError = (formEl, selectEl, selectContainer) => {
  selectEl.firstChild.value = 'no-address';
  selectEl.firstChild.innerHTML = 'Ingen adresse';
  setHasValueClass(selectContainer);

  // Create the error label from scratch
  const errorEl = document.createElement('label');
  errorEl.classList.add('wpforms-error');
  errorEl.innerText = selectContainer.dataset.addressPickerErrorMessage;

  selectContainer.appendChild(errorEl);

  const submitBtn = formEl.querySelector('button[type="submit"]');

  // Stop the form from submitting and scroll to the form field to make sure the user sees the error.
  submitBtn.addEventListener('click', (e) => {
    e.preventDefault();
    selectContainer.scrollIntoView({ behavior: 'smooth' });
  });
};

/**
 * Retrieves the addresses of the authenticated user.
 */
const getAddresses = async () => {
  const login = Alpine.store('Login');
  const accessToken = login.getTokenFromSessionStorage(login.storedTokens.ACCESS_TOKEN);
  const idToken = login.getTokenFromSessionStorage(login.storedTokens.ID_TOKEN);

  return fetch(`${SELF_SERVICE_API_HOST}/service/web/v1/addresses`, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      IdToken: idToken,
    },
  }).then((response) => response.json());
};

/**
 * Injects the user's addresses into the address picker dropdown field.
 */
const injectAddresses = (addresses, selectEl, selectContainer) => {
  selectEl.innerHTML = '';
  addresses.forEach((address) => {
    const powerSupplyDelivery = address?.deliveries?.find(
      (delivery) => delivery?.commodity === 'PowerSupply'
    );

    if (!powerSupplyDelivery) {
      return;
    }

    const meteringPointId = powerSupplyDelivery.metering_point_id;

    const optionEl = document.createElement('option');
    optionEl.value = meteringPointId;
    optionEl.innerHTML = address?.display_address;
    selectEl.appendChild(optionEl);

    // Pick the first address by default
    if (selectEl.options.length === 1) {
      selectEl.value = meteringPointId;
    }
  });

  setHasValueClass(selectContainer);
};
